"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axiosConfig = void 0;

var _lodash = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @module Helper */

/**
 * Return merged default config for a new axios instance
 * @param {String} accessToken the access token to insert in the Header
 * @param {Object} otherConfig the other config that will be merged with headers.Authorization
 * @returns {Object} the axios deep merged config
 * @memberof Helper
 * @example
 * import { Helper } from "@rentspree/axios-refresh-token"
 * AxiosRefreshToken.axiosConfig("an-access-token", {headers: { ...additional header }} )
 */
var axiosConfig = function axiosConfig(accessToken) {
  var otherConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _lodash.default)(otherConfig, {
    headers: {
      Authorization: "Bearer ".concat(accessToken)
    }
  });
};

exports.axiosConfig = axiosConfig;